var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6983_50766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5C16.5 16.6 15.6 17.5 14.5 17.5H3.5C2.4 17.5 1.5 16.6 1.5 15.5V7C1.5 5.9 2.4 5 3.5 5H14.5C15.6 5 16.5 5.9 16.5 7V15.5Z",
    fill: "#FDD888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.5C18 6.6 17.1 7.5 16 7.5H2C0.9 7.5 0 6.6 0 5.5C0 4.4 0.9 3.5 2 3.5H16C17.1 3.5 18 4.4 18 5.5Z",
    fill: "#FDD888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5H16.5V8.5H1.5V7.5Z",
    fill: "#FCAB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5H8.5C8.10218 1.5 7.72064 1.65804 7.43934 1.93934C7.15804 2.22064 7 2.60218 7 3V17.5H11V3C11 2.60218 10.842 2.22064 10.5607 1.93934C10.2794 1.65804 9.89782 1.5 9.5 1.5Z",
    fill: "#DA2F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00054 3.49982C8.55054 3.49982 8.63204 3.24182 8.18104 2.92632L4.82004 0.57332C4.71692 0.498233 4.59897 0.445992 4.47407 0.420079C4.34916 0.394167 4.22017 0.395178 4.09569 0.423046C3.9712 0.450914 3.85409 0.504998 3.75216 0.581693C3.65022 0.658388 3.56581 0.755931 3.50454 0.86782L2.49654 2.63182C2.22354 3.10932 2.45054 3.49982 3.00054 3.49982H8.00054ZM10.0005 3.49982C9.45054 3.49982 9.36904 3.24182 9.82004 2.92632L13.1815 0.57332C13.2847 0.498313 13.4026 0.446138 13.5275 0.42027C13.6524 0.394402 13.7814 0.395434 13.9058 0.423297C14.0303 0.451159 14.1474 0.505213 14.2493 0.581861C14.3513 0.658509 14.4357 0.755991 14.497 0.86782L15.505 2.63132C15.7775 3.10932 15.5505 3.49982 15.0005 3.49982H10.0005Z",
    fill: "#DA2F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6983_50766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.4aafb5dd8d33a3173cd760c743e4d43a.svg";
export { ForwardRef as ReactComponent };